import { AppBar, Box, Drawer, Icon, Toolbar, Typography, IconButton, styled } from '@mui/material';
import * as React from 'react';
import MessageDialog from './MessageDialog';
import * as AuthStore from '../store/Auth';
import { useSelector } from 'react-redux';
import { LoaderBackdrop } from './LoaderBackdrop';
import NavDrawer from './NavDrawer';

import Breadcrumbs from './Breadcrumbs';
import DialogProvider from './DialogProvider';
import { ImageSearch } from './ImageSearch';

const drawerWidth = 300;

const StyledAppBar = styled(AppBar)(({ theme }) => ({
    [theme.breakpoints.up('sm')]: {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: drawerWidth
    }
}));

const MenuButton = styled(IconButton)(({ theme }) => ({
    marginRight: theme.spacing(1),
    marginLeft: theme.spacing(1),
    [theme.breakpoints.up('sm')]: {
        display: 'none'
    }
}));

const PageTitleToolbar = styled(Toolbar)(({ theme }) => ({
    background: `linear-gradient(90deg,${theme.palette.primary.light} , ${theme.palette.primary.dark})`
}));

const PageTitle = styled(Typography)(({ theme }) => ({
    flex: 1,
    textTransform: 'uppercase' as const,
    letterSpacing: theme.spacing(1),
    paddingLeft: 1
}));

const StyleContainer = styled('div')({
    display: 'flex',
    width: '196px',
    justifyContent: 'space-evenly'
});

const ParaDecoration = styled('div')(({ theme }) => ({
    width: theme.spacing(3),
    height: theme.spacing(4),
    transform: 'skew(-35deg)',
    background: theme.palette.primary.light
}));

const Root = styled('div')({
    display: 'flex',
    height: '100%'
});

const DrawerNav = styled('nav')(({ theme }) => ({
    [theme.breakpoints.up('sm')]: {
        width: drawerWidth,
        flexShrink: 0
    }
}));

const Content = styled(Box)({
    flexGrow: 1,
    width: `calc(100% - ${drawerWidth}px)`
});
export default function Layout(props: any) {
    const [mobileOpen, setMobileOpen] = React.useState(false);
    //const pageTitle = useSelector(ApplicationStore.selectors.getPageTitle);
    const switchAccount = useSelector(AuthStore.selectors.getSwitchProfile);
    const logout = useSelector(AuthStore.selectors.getLogout);

    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };

    return (
        <React.Fragment>
            <DialogProvider>
                <MessageDialog />
                <StyledAppBar position="fixed">
                    <PageTitleToolbar disableGutters variant='dense' {...props}>
                        <MenuButton color='inherit' aria-label='open drawer' edge='start' onClick={handleDrawerToggle}>
                            <Icon>menu</Icon>
                        </MenuButton>
                        <PageTitle variant='h6' noWrap>
                            <Breadcrumbs />
                        </PageTitle>
                        {/* <ImageSearch /> */}
                        <StyleContainer>
                            <ParaDecoration>&nbsp;</ParaDecoration>
                            <ParaDecoration>&nbsp;</ParaDecoration>
                            <ParaDecoration>&nbsp;</ParaDecoration>
                            <ParaDecoration>&nbsp;</ParaDecoration>
                        </StyleContainer>
                    </PageTitleToolbar>
                </StyledAppBar>
                <Root>
                    <DrawerNav>
                        <Box sx={{ display: { sm: 'none', xs: 'block' } }}>
                            <Drawer
                                variant='temporary'
                                open={mobileOpen}
                                onClose={handleDrawerToggle}
                                sx={{ '& .MuiDrawer-paper': { width: drawerWidth } }}
                                ModalProps={{
                                    keepMounted: true
                                }}>
                                <NavDrawer />
                            </Drawer>
                        </Box>
                        <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
                            <Drawer
                                sx={{ '& .MuiDrawer-paper': { width: drawerWidth } }}
                                variant='permanent'
                                open>
                                <NavDrawer />
                            </Drawer>
                        </Box>
                    </DrawerNav>
                    <Box component='main' sx={{ flexGrow: 1, width: `calc(100% - ${drawerWidth}px)` }} display='flex' flexDirection='column'>
                        <Toolbar variant='dense' />
                        {props.children}
                    </Box>

                    {((switchAccount.is || false) || (logout.is || false)) && <LoaderBackdrop />}
                </Root>
            </DialogProvider>
        </React.Fragment>
    );
}